import { Alert, AlertDescription, AlertTitle, Box } from '@chakra-ui/react';
import dayjs from 'dayjs';
import * as React from 'react';
import { useCountdown, useInterval, useTimeout } from 'usehooks-ts';

export const EventPreviewWarning: React.FC<{
  canRecord: boolean;
  autoRecord: boolean;
  startDate: Date;
  endDate: Date;
}> = ({ canRecord, autoRecord, startDate, endDate }) => {
  const [isBeforeStartDate, setIsVisible] = React.useState(
    dayjs().isBefore(startDate)
  );

  useInterval(
    () => {
      setIsVisible(dayjs().isBefore(startDate));
    },
    isBeforeStartDate ? 1000 : null
  );

  if (!isBeforeStartDate) {
    return null;
  }

  return (
    <Alert status="warning" variant="subtle">
      <AlertDescription>
        <AlertTitle>
          Attendees will be able to join this event 5 minutes before the
          official start time
        </AlertTitle>
        {canRecord && autoRecord && (
          <AlertDescription>
            This event will be automatically recorded at the start time of the
            event
          </AlertDescription>
        )}
      </AlertDescription>
    </Alert>
  );
};
